import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const Lista = ({handleLista, list}) => {
    return(
        <div>
            <select className="ui simple selection dropdown fluid" name="clase" id="miLista" onChange={handleLista}>
                <option>Seleccionar...</option>
                <option>TECNICA</option>
                <option>RECAUDO</option>
                <option>VENTAS</option>
            </select>
        </div>
    )
};

const AddTire2 = ({styles, list, handleLista, handleSubmit, handleChange, args, errors}) => {
    return(
        <div>
            <button className="ui right labeled icon button" style={styles.titBuscar}>
                <i className="large plus yellow icon"></i>
                Tipo de recurso nuevo
            </button>
            <div style={styles.box}>
                <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
                    <div className="ui one column stackable grid">
                        <div className="row container">
                            <div className="column" width="100%">
                                <Form.Field>
                                    <label style={styles.label}>Descripción</label>
                                    <Form.Input autoComplete="off" name="descrTipoRec" id="descrTipoRec" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrTipoRec'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Area de aprovechamiento</label>
                                    <Lista list={list} styles={styles} handleLista={handleLista} />
                                </Form.Field>

                                <Button style={styles.confirmar} type='submit' fluid>
                                    AGREGAR
                                </Button>

                                {
                                    errors.length?<Message negative header="Los siguientes errores:"
                                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                                }
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default AddTire2
